import React from 'react';
import FAQcordion from "src/components/TDP/UI/FAQcordion";
import SliderImage from "./SliderTextBubbles/SliderImage";
import {contentURL} from "src/utilities/utilityFunctions";

const FAQSlide=()=>{
    return (
        <div className="ls-slide" data-ls="slidedelay:8500" id="faqSlide">
            <SliderImage src={contentURL() + "/site/images/layerslider-gallery-tn/blackboard-kids.png"}
                         className="ls-bg"
                         alt="Slide background"
                        top={0}
            />
             <div className="ls-l" style={{top:125,left:"50%",border:"dashed gold 0px"}}>
                <FAQcordion/>
             </div>

        </div>
    )
};
export default FAQSlide;
